import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '../service/permission.service';
@Directive({
  selector: '[appIsGranted]'
})
export class IsGrantedDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) { }
  
  @Input() 
  public appIsGranted!:string;
  @Input()
  public appIsGrantedModule!:string;
  ngOnInit() {
 
    this.isGranted(this.appIsGrantedModule, this.appIsGranted);
  }
  private isGranted(appIsGrantedModule:any, appIsGranted: string) {
    if (this.permissionService.checkUserRightsWithNoAlert(appIsGrantedModule,appIsGranted)){
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}